   <svelte:head>
    <link href="https://fonts.googleapis.com/css?family=Raleway:100,200,300,400,500,600,700,800,900&display=swap" rel="stylesheet">

    <title>en-curta.me</title>

<!-- 

Breezed Template

https://templatemo.com/tm-543-breezed

-->
    <!-- Additional CSS Files 
    <link rel="stylesheet" type="text/css" href="assets/css/bootstrap.min.css">-->

    <link rel="stylesheet" type="text/css" href="assets/css/font-awesome.css">

    <link rel="stylesheet" href="assets/css/templatemo-breezed.css">

    <link rel="stylesheet" href="assets/css/owl-carousel.css">

   <!-- <link rel="stylesheet" href="assets/css/lightbox.css">-->
   <script src="assets/js/jquery-2.1.0.min.js"></script>

    <!-- Bootstrap 
    <script src="assets/js/popper.js"></script>-->
    <script src="assets/js/bootstrap.min.js"></script>

    <!-- Plugins -->
   <!-- <script src="assets/js/owl-carousel.js"></script>
    <script src="assets/js/scrollreveal.min.js"></script>
    <script src="assets/js/waypoints.min.js"></script>
    <script src="assets/js/jquery.counterup.min.js"></script>
    <script src="assets/js/imgfix.min.js"></script> 
    <script src="assets/js/slick.js"></script> 
    <script src="assets/js/lightbox.js"></script> 
    <script src="assets/js/isotope.js"></script> -->
    
    <!-- Global Init  
    <script src="assets/js/custom.js"></script>-->

    
   </svelte:head> 
 <script>
export let cor1="black";
export let cor2="black";
export let tela="black";
export let tipoUsuario="Básico";
export let login="";
export let logado=false;
export let contato="https://api.whatsapp.com/send?phone=5581996280325";
import {createEventDispatcher } from 'svelte';


$:if(tela=="construtor"){
    console.log("mudou cor");
    cor1="white";
    cor2="black";

}else{
    console.log("mudou cor1");
 cor1="black";
 cor2="white";

};
const dispatch = createEventDispatcher();
function ChamarTela(e) {
  
    console.log("chamando tela "+e);
    dispatch("ChamarTela", e);
}
function ClasseFundoPreto(){
    
    if(tela=="construtor"){
        tela1= "black";
    }else{
        tela1= "white";
    }
}
function ClasseBranco(){
    if(tela=="construtor"){
        return "branco"; 
    }else{
        return "";
    }
}
 </script>

 <header class="header-area header-sticky  " style="background-color:{cor1}"  >
 

 
        <div class="container">
            <div class="row"> 
                <div class="col-12">
                    <nav class="main-nav">
                        <!-- ***** Logo Start ***** -->
                        <a href="index.html" class="logo" style="color:{cor2}">
                            Microssites
                        </a>
                        <!-- ***** Logo End ***** -->
                        <!-- ***** Menu Start ***** --> 
                        <ul class="nav" >
                        
{#if login=="" }
                            <li class=""><a on:click={(e)=>ChamarTela("home")} class="active" style="color:{cor2}">Home</a></li>
                            <li class="" on:click={(e)=>ChamarTela("login")}><a style="color:{cor2}">Logar</a></li>
                            <li class=""><a on:click={(e)=>ChamarTela("cadastro")} style="color:{cor2}">Cadastrar</a></li>
 {:else if logado }
<li class=""><a on:click={(e)=>ChamarTela("home")} class="active" style="color:{cor2}">Home</a></li>

   <li class="" ><a style="color:{cor2}">{login} <i> Usuário:{tipoUsuario}</i></a></li>
                       
 {/if}                           
                            <li class="scroll-to-section"><a href="{contato}">Fale conosco</a></li> 
                           <!-- <div class="search-icon">
                                <a href="#search"><i class="fa fa-search"></i></a>
                            </div>-->
                        </ul>        
                        <!--<a class='menu-trigger' href=" "> 
                            <span>Menu</span>
                        </a>-->
                        <!-- ***** Menu End ***** -->
                    </nav>   
                </div>
            </div>
        </div>  
    </header>

    <style>
    .fundo-preto{
        background-color:black;
    }
     .branco{
        color:white;
    }
    
   
    </style>